import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonHeader from "../CommonHeader";
import { appNotAvailable, apps, sats } from "../messages";
import { Box } from "@mui/material";
import CollectionList from "./CollectionList";
import CategoriesList from "./categories/CategoriesList";
import "../../assets/apps.scss";
import AppDetailsDialog from "./AppDetailsDialog";
import { useDispatch, useSelector } from "react-redux";
import InstalledAppDialog from "./InstalledAppDialog";
import WalletSymbols from "../WalletSymbols";
import MyAppsMainList from "./myApps/MyAppsMainList";
import { sessionService } from "redux-react-session";
import {
  callAPIInterface,
  handleOpenAppDetailDialogAndPassDetails,
  handleOpenAppDialog,
  removedAppStatus,
} from "../constants";
import { showToast } from "../../redux/actions";

function MiniApps() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(location.search);
  const appId = urlParams.get("app_id");

  const { isAppDetailOpen, isOpenInstalledAppDialog } = useSelector(
    (state) => state.common
  );

  useEffect(() => {
    getLnAddress();
  }, []);

  useEffect(() => {
    if (appId) {
      fetchAppDetails(appId);
    }
  }, [appId]);

  const fetchAppDetails = async (appId) => {
    try {
      const response = await callAPIInterface(
        "GET",
        `/manage-app/apps/${appId}`
      );

      if (removedAppStatus.includes(response?.status)) {
        navigate("/apps");
        return dispatch(
          showToast({
            isToastOpen: true,
            toastMessage: appNotAvailable,
            toastVariant: "error",
          })
        );
      }
      if (response.is_app_installed) {
        handleOpenAppDialog({ data: response });
      } else {
        handleOpenAppDetailDialogAndPassDetails({
          id: appId,
        });
      }
      navigate("/apps"); // remove app_id from URL
    } catch (err) {
      console.log("Error while fetching app details:", err);
    }
  };

  const searchComponent = (
    <WalletSymbols
      symbol="search"
      action={() => navigate("search")}
      sx={{ cursor: "pointer" }}
    />
  );

  const getLnAddress = async () => {
    try {
      const apiData = {
        status: "active",
        currency: sats,
      };
      const session = await sessionService.loadSession();

      const paymentAddressRes = await callAPIInterface(
        "POST",
        "/payment-addresses/filter?limit=1",
        JSON.stringify(apiData)
      );
      if (paymentAddressRes) {
        sessionService.saveSession({
          ...session,
          lnAddressSATS: paymentAddressRes?.data?.[0]?.address,
        });
      }
    } catch (err) {
      console.log("Error while fetching ln address", err);
    }
  };

  return (
    <>
      <CommonHeader textAfterIcon={apps} rightSideComponent={searchComponent} />
      <Box className="options-container overflow-auto mini-app-container">
        <MyAppsMainList />
        <CollectionList isFromMainList={true} />
        <CategoriesList />
        {isAppDetailOpen && <AppDetailsDialog />}
        {isOpenInstalledAppDialog && <InstalledAppDialog />}
      </Box>
    </>
  );
}

export default MiniApps;
